
<c-app-content
    :sites           = "siteContext ? [ { id: siteContext } ] : null"
    :hide-top        = "!siteContext"
    :search-on-focus = "false"
    @initialized     = "onInitialized"
>
    <template v-slot:content>
        <div
            id="incidents-search-panel"
            class="overview-panel v-flex"
            :key="count"
        >
            <c-inc-overview-menu
                :site     = "siteContext"
                @download = "onDownload"
                @refresh  = "onRefresh"
                @filter   = "onFilter"
            />
            <div>
                <table id="inc-overview" class="table table-hover table-bordered">
                    <thead>
                    <tr class="table-header" >
                        <th class="text-center" >
                            <v-table-header-cell
                                group="inc.overview.header"
                                first   = "state"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center" >
                            <v-table-header-cell
                                group="inc.overview.header"
                                first   = "begin"
                                second  = "end"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center" >
                            <v-table-header-cell
                                group="inc.overview.header"
                                first   = "type"
                                second  = "status"
                                :sortable="{ first: true, second: false}"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center" >
                            <v-table-header-cell
                                group="inc.overview.header"
                                first   = "user"
                                second  = "id"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center" >
                            <v-table-header-cell
                                group="inc.overview.header"
                                first   = "fabricNo"
                                second  = "siteId"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center">
                            <v-table-header-cell
                                group   ="inc.overview.header"
                                first   = "street"
                                second  ="city"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center">Angebot<br>Auftrag</th>
                        <th class="text-center">Rechnung<br>{{ filter && filter.field === "incidentMntQuery" ? 'Wartungsnehmer' : 'Ausf. Unternehmen' }}  </th>
                        <th class="text-center">Beschreibung</th>
                        <th class="text-center">Maßname</th>
                    </tr>
                    </thead>
                </table>
            </div>
        </div>
    </template>
</c-app-content>
